import BlogCategoriesBlock from './BlogCategoriesBlock'
import BlogDateBlock from './BlogDateBlock'
import BlogTitleBlock from './BlogTitleBlock'
import BlogExcerptBlock from './BlogExcerptBlock'
import BlogFeaturedImage from './BlogFeaturedImage'

export const BlogFeaturedPost = ({ post, categories }) => {
    return (
        <div className="bg-white overflow-hidden mb-6 border-b border-gray-200">
            <div className="relative w-full h-96 bg-gray-200 rounded-lg">
                <BlogFeaturedImage post={post} />
            </div>
            <div className="py-6 px-1">
                <div className="text-sm flex font-normal text-orange-600 uppercase tracking-wide">
                    <BlogCategoriesBlock post={post} categories={categories} />
                    <div className="px-1"></div>
                    <BlogDateBlock post={post} />
                </div>
                <BlogTitleBlock size={'text-3xl leading-11'} post={post} />
                <BlogExcerptBlock post={post} />
            </div>
        </div>
    )
}
